import { countSeens, isDurationControlled } from "../../student/video/func";

export const addVideo = async ({
    otp,
    playbackInfo,
    videoContainerRef,
    setDisplay,
    dispatch,
    data,
    setPlaybackStarted,
}) => {
    if (!otp || !playbackInfo) return;
    videoContainerRef.current?.classList.add("haveVideo");
    if (isDurationControlled(data) && !data?.views_count) {
        countSeens(dispatch, data);
    }
    setPlaybackStarted(true);
    setDisplay("none");
};
